export default {
  nav: {
    home: 'Home',
    categories: 'Categories',
    shoppingGuide: 'Shopping Guide',
    explore: 'Explore Spreadsheet',
  },
  hero: {
    badge: 'Independent informational resource',
    title: 'USFans Spreadsheet — Creator Lists, Guides & Resources',
    subtitle:
      'An organized hub of guides, comparisons and resources about USFans creators, shipping, coupons and safety — all in one clear place.',
    ctaSpreadsheet: 'USFans Spreadsheet',
    ctaBuy: 'Buy It Now',
    mockupTitle: 'Creator Spreadsheet',
    mockupSearch: 'Search creators...',
    mockupColCategory: 'Category',
    mockupColName: 'Name',
    mockupColStatus: 'Status',
    mockupStatusActive: 'Active',
    mockupStatusNew: 'New',
    mockupNote: 'Sorted by category · filterable',
  },
  trust: {
    title: 'Why use a USFans Spreadsheet?',
    item1Title: 'Updated information',
    item1Desc: 'We keep guides, comparisons and resources fresh and relevant.',
    item2Title: 'Clear information',
    item2Desc: 'Organized into easy-to-browse categories.',
    item3Title: 'Safety first',
    item3Desc: 'Never share passwords, verification codes or sensitive data.',
    item4Title: 'Independent guide',
    item4Desc: 'Informational content — not an official USFans website.',
  },
  categories: {
    title: 'Browse by Category',
    subtitle: 'Pick a category below to explore the full collection on our main store.',
    dropdownLabel: 'Choose a category',
    dropdownHint: 'Select a category to open it',
    items: {
      shoes: 'Shoes',
      hoodies: 'Hoodies & Sweaters',
      tshirts: 'T-Shirts',
      jackets: 'Jackets',
      pants: 'Pants & Shorts',
      headwear: 'Headwear',
      sets: 'Sets',
      underwear: 'Underwear',
      jersey: 'Jerseys',
      accessories: 'Accessories',
      bags: 'Bags',
      belts: 'Belts',
      perfumes: 'Perfumes',
      other: 'Other Stuff',
    },
  },
  about: {
    title: 'What is USFans Spreadsheet?',
    lead:
      'USFans Spreadsheet is a structured way to browse and organize information about creators, resources and guides connected to the USFans platform.',
    p1: 'Our goal is to help you find what you need without searching across many different pages. With a clear layout you can compare creators, check categories and jump straight to the right source faster.',
    p2: 'Spreadsheets are especially useful for beginners who want a broad overview first, before diving deeper into individual creators or resources.',
    listTitle: 'Key benefits:',
    list: [
      'Organized information in one place',
      'Faster searching and filtering',
      'Beginner-friendly guides',
      'Side-by-side comparisons',
      'Updated safety notes',
      'Refreshable, shareable structure',
    ],
  },
  articleCta: {
    title: 'Read the full USFans Spreadsheet guide',
    subtitle:
      'Learn more about creator lists, directories, comparisons and safety tips in our in-depth guide.',
    button: 'Open the guide',
  },
  articles: {
    title: 'USFans Guides & Resources',
    subtitle: 'In-depth guides on reviews, shipping, coupons, warehouse, safety and more.',
    readMore: 'Read guide',
  },
  footer: {
    disclaimer:
      'USFansLink is an independent informational resource and is not affiliated with or operated by USFans.',
    rights: 'All rights reserved.',
    backHome: 'Home',
    mainSite: 'Visit main website',
  },
};